<template>
    <div ref="splitPane" class="split-pane" :class="direction" :style="{ flexDirection: direction }">
        <div class="pane pane-one" :style="lengthType + ':' + paneLengthValue">
            <slot name="one"></slot>
        </div>

        <div
                class="pane-trigger"
                :style="lengthType + ':' + triggerLengthValue"
                @mousedown="handleMouseDown"
                v-if="paneLengthPercent < 99"
        >

            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on"
                           outlined
                           small
                           icon
                           @click="closeSeparate()"
                           style="z-index: 9999; margin-left: -10px; margin-top: -30px; position: absolute; border: none;">
                        <v-icon style="font-size: 30px;">mdi-play</v-icon>
                    </v-btn>
                </template>
                <span>Code Preview Close</span>
            </v-tooltip>
        </div>

        <div v-if="paneLengthPercent < 99" class="pane pane-two">
            <slot name="two"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name : 'separate-panel-components',
        props: {
            direction: {
                type: String,
                default: 'row'
            },

            min: {
                type: Number,
                default: 0
            },

            max: {
                type: Number,
                default: 100
            },

            paneLengthPercent: {
                type: Number,
                default: 50
            },

            triggerLength: {
                type: Number,
                default: 5
            }
        },
        data() {
            return {
                triggerLeftOffset: 0, //        ( )
            }
        },
        computed: {
            lengthType() {
                return this.direction === 'row' ? 'width' : 'height'
            },

            paneLengthValue() {
                return `calc(${this.paneLengthPercent}% - ${this.triggerLength / 2 + 'px'})`
            },

            triggerLengthValue() {
                return this.triggerLength + 'px'
            }
        },

        methods: {
            closeSeparate(){
                this.$emit('close')
                // this.$emit('update:paneLengthPercent', 100)
            },
            //
            handleMouseDown(e) {
                document.addEventListener('mousemove', this.handleMouseMove)
                document.addEventListener('mouseup', this.handleMouseUp)

                if (this.direction === 'row') {
                    this.triggerLeftOffset = e.pageX - e.srcElement.getBoundingClientRect().left
                } else {
                    this.triggerLeftOffset = e.pageY - e.srcElement.getBoundingClientRect().top
                }
            },

            //
            handleMouseMove(e) {
                const clientRect = this.$refs.splitPane.getBoundingClientRect()
                let paneLengthPercent = 0

                if (this.direction === 'row') {
                    const offset = e.pageX - clientRect.left - this.triggerLeftOffset + this.triggerLength / 2
                    paneLengthPercent = (offset / clientRect.width) * 100
                } else {
                    const offset = e.pageY - clientRect.top - this.triggerLeftOffset + this.triggerLength / 2
                    paneLengthPercent = (offset / clientRect.height) * 100
                }

                if (paneLengthPercent < this.min) {
                    paneLengthPercent = this.min
                }
                if (paneLengthPercent > this.max) {
                    paneLengthPercent = this.max
                }

                this.$emit('update:paneLengthPercent', paneLengthPercent)
            },

            //
            handleMouseUp() {
                document.removeEventListener('mousemove', this.handleMouseMove)
            }
        }
    }
</script>

<style scoped lang="scss">
    .split-pane {
        background: white;
        height: 100%;
        display: flex;
        &.row {
            .pane {
                height: 100%;
            }
            .pane-trigger {
                margin-top: 2%;
                height: 93%;
                cursor: col-resize;

            }
        }
        &.column {
            .pane {
                width: 100%;
            }
            .pane-trigger {
                width: 100%;
                cursor: row-resize;
            }
        }
        .pane-one {
            margin-left: 10px
            /*background: palevioletred;*/
        }
        .pane-trigger {
            user-select: none;
            background: lightgrey;
            position: relative;
        }
        .pane-trigger:hover{
            user-select: none;
            background: grey;
            position: relative;
        }
        .pane-two {
            flex: 1;
            /*background: turquoise;*/
        }
    }
</style>